<div class="mainInfo">
  <h1>Registro Finalizado</h1>
  <p>{{ displaySubTitle }}</p>
</div>

<div class="msgBlock pt-30" *ngIf="isMexico">
  <div class="msgBlock__wrapper">
    <div class="msgBlock__content">
      <div class="top bigBottomPad">
        <app-sales-credit-codes-shared
          [contractNumber]="contractNumber"
          [personNumber]="personNumber">
        </app-sales-credit-codes-shared>
      </div>
    </div>
  </div>
</div>

<div class="datacultr-instructions" *ngIf="!isMexico">
  <div class="datacultr-instructions__wrapper">
    <div class="datacultr-instructions__list">
      <div class="instruction-item" *ngFor="let step of steps">
        <div class="instruction-item__number">
          <span>{{ step.number }}</span>
        </div>
        <div class="instruction-item__text">
          <p>{{ step.text }}</p>
        </div>
      </div>
    </div>
    <div class="datacultr-instructions__footer">
      <p>No es necesario hacerlo en la tienda; el cliente puede completarlo luego con tranquilidad.</p>
    </div>
  </div>
</div>

<footer class="pt-30">
  <div class="footer__content">
    <app-phone-app-footer-button-shared [state]="appState" (continueClick)="onContinue()"></app-phone-app-footer-button-shared>
  </div>
</footer>
